// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner-container-R6iME","visible":"Spinner-visible-3deeN","hidden":"Spinner-hidden-ndje5","spinner":"Spinner-spinner-3rgQO","spin":"Spinner-spin-7P21d"};